import { AloftPrice } from '@aloft/toolkit-shared';

export const getRenovationBudgetBelowValueIncreaseWarning = ({
  opinionOfMarketValue,
  opinionOfAfterRepairValue,
  totalRenovationBudget,
}: {
  opinionOfMarketValue?: AloftPrice;
  opinionOfAfterRepairValue?: AloftPrice;
  totalRenovationBudget?: AloftPrice;
}): string | undefined => {
  if (!opinionOfMarketValue || !opinionOfAfterRepairValue) return undefined;

  const valueIncrease = opinionOfAfterRepairValue.sub(opinionOfMarketValue);
  if (!valueIncrease.gt(AloftPrice.zero)) return undefined;

  const renovationBudget = totalRenovationBudget ?? AloftPrice.zero;
  if (!renovationBudget.lt(valueIncrease.mul(0.1))) return undefined;

  return `The renovation budget should typically be at least 10% of the value increase (${valueIncrease.toString()}).`;
};
